import { SportsMemCondition, SportsMemPurchaseCondition } from './constants';

const attributes = {
  sport_type: {
    friendly: 'Sport',
    validations: {
      maxLength: 150,
    },
  },
  sport_item_type: {
    friendly: 'Item Type',
    validations: {
      maxLength: 150,
    },
  },
  sport_team: {
    friendly: 'Team',
    validations: {
      maxLength: 150,
    },
  },
  sport_player: {
    friendly: 'Player',
    validations: {
      maxLength: 150,
    },
  },
  sport_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  sport_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 150,
    },
  },
  sport_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },
  sport_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },
  sport_signed: {
    friendly: 'Signed',
    validations: {
      maxLength: 255,
    },
  },
  sport_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },
  sport_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 150,
    },
  },
  sport_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },
  sport_conditon: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: SportsMemCondition,
    },
  },
  sport_purchase_condtion: {
    friendly: 'Purchase condition',
    validations: {
      type: 'enum',
      enumType: SportsMemPurchaseCondition,
    },
  },

};

export default attributes;

export const SportsMemDefaultSplitAttribute = 'sport_item_type';

export const SportsMemItemSearchAttributes = [];

export const SportsMemOverviewAttributes = ['title', 'sport_item_type', 'sport_type', 'sport_year', 'sport_country', 'sport_conditon', 'rarity',
  'market_value', 'quantity', 'inventory_no', 'tags',
];

export const SportsMemSpecificationAttributes = ['sport_player', 'sport_team', 'sport_edition', 'sport_maker', 'sport_material', 'sport_dimensions',
  'sport_weight', 'sport_signed',
];

export const SportsMemPurchaseAttributes = ['purchase_date', 'purchase_price', 'sport_purchase_condtion', 'purchase_contact', 'purchase_notes'];

export const SportsMemDetailAttributes = [];

export const SportsMemRequiredAttributes = [];

export const SportsMemDisplayAttributes = ['sport_item_type', 'sport_type', 'sport_team', 'sport_year', 'tags'];

export const SportsMemSliderGalleryAttributes = {
  titleKey: 'sport_type',
  subtitleKey: 'sport_item_type',
};



// WEBPACK FOOTER //
// ./src/config/sportsMemorabiliaDataAttributes.js